'use strict';
import * as $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dCertificate$002dOf$002dOrigin$002dAuthority$0024 from "./app.data.data_point_types$package$-Certificate-Of-Origin-Authority$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$() {
  this.aHk = null;
  this.aHB = null;
  this.aHn = null;
  this.aHo = false;
  this.aHt = null;
  this.aHu = false;
  this.aHz = null;
  this.aHA = false;
  this.aHl = null;
  this.aHm = false;
  this.aHx = null;
  this.aHy = false;
  this.aHv = null;
  this.aHw = false;
  this.aHp = null;
  this.aHq = false;
  this.aHr = null;
  this.aHs = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$ = this;
  this.aHk = $j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dCertificate$002dOf$002dOrigin$002dAuthority$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$();
  this.aHB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002edata$005fpoint$005ftypes$0024package$0024$002dCertificate$002dOf$002dOrigin$002dAuthority$0024.$m_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthority$());
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$.prototype = $p;
$p.eR = (function() {
  return this.aHk;
});
$p.eO = (function() {
  return this.aHB;
});
$p.bW = (function() {
  if ((!this.aHo)) {
    this.aHn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aHo = true;
  }
  return this.aHn;
});
$p.b9 = (function() {
  if ((!this.aHu)) {
    this.aHt = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aHu = true;
  }
  return this.aHt;
});
$p.b3 = (function() {
  if ((!this.aHA)) {
    this.aHz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aHA = true;
  }
  return this.aHz;
});
$p.aG = (function() {
  if ((!this.aHm)) {
    this.aHl = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aHm = true;
  }
  return this.aHl;
});
$p.az = (function() {
  if ((!this.aHy)) {
    this.aHx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aHy = true;
  }
  return this.aHx;
});
$p.aY = (function() {
  if ((!this.aHw)) {
    this.aHv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aHw = true;
  }
  return this.aHv;
});
$p.bN0 = (function() {
  if ((!this.aHq)) {
    this.aHp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Certificate of Origin Authority";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aHq = true;
  }
  return this.aHp;
});
$p.bNv = (function() {
  if ((!this.aHs)) {
    this.aHr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_components_TextKindFor$().jx;
    this.aHs = true;
  }
  return this.aHr;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$, "app.data.data_point_types$package$CertificateOfOriginAuthorityForm$", ({
  Fx: 1,
  N: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$CertificateOfOriginAuthorityForm$ };
//# sourceMappingURL=app.data.data_point_types$package$-Certificate-Of-Origin-Authority-Form$.js.map
